import { createSlice } from "@reduxjs/toolkit";

const vendorSlice = createSlice({
    name:"vendors",
    initialState:{
        vendors:null
    },
    reducers:{
        setVendorList(state,action){
            state.vendors = action?.payload;
        },
    }
})


export const {setVendorList} = vendorSlice.actions
export default vendorSlice.reducer